module.exports = function preparePostInitFunction(options, instead) {

  function sharedFunction (component, context) {
    if (!Modernizr.touchevents) {

      context.find('select').each(function(){
        //Označovanie vybraného prvku v selectu robilo problémy
        //Vyberiem hodnotu označeného optionu (s atribútom selected)
        var selectedValue = $(this).find('option[selected="selected"]').val();
        var sel = new Select({
            el: this,
            alignToHighlighted: 'always'
        });

        //Zmením hodnotu nového selectu podľa predtým uloženej
        if(selectedValue)
          sel.change(selectedValue);
      });

      //Natvrdo intervalu označím prvý option. Označoval sa tretí
      var int_option = $('#search_interval option[selected="selected"]');
      if(int_option)
        int_option.attr("selected",true);
    }
    else {
      context.find('select').each(function(){
        $(this).selectTouch();
      });
    }
  }

  // postInitHook funkce pro letenky
  function letenky (component, context) {
    var opts = context.data('opts');

    sharedFunction(component, context);

    window.airSelectPostRenderFunction = function() {
      sharedFunction(null, $('#airticket-airline-block'));
    }

    var visible = context.find('#visible-part');
    var hidden = context.find('#hidden-part');

    var showMore = `<i class="sa-icon icon-sipka-dolu"></i>${opts.messages.showMore}`;
    var showLess = `<i class="sa-icon icon-sipka-dolu up"></i>${opts.messages.showLess}`;

    var toggleDiv = $('<div/>', {'class': 'toggle-form'});
    var toggleButton = $(`<a>${showMore}</a>`).appendTo(toggleDiv);

    toggleButton.click(toggleForm);

    toggleDiv.insertBefore(hidden);

    function toggleForm() {
      var hiddenPartIsVisible = hidden.is(':visible');
      var button = context.find('.toggle-form a');

      if (hiddenPartIsVisible) {
        button.html(showMore);
        hidden.hide('fast');
      } else {
        button.html(showLess);
        hidden.show('fast');
      }
    }

    function getIntervalSelect() {
      var instance = null;
      $('#form-1').find('select#search_interval').each(function() {
        instance = this.selectInstance;
      });
      return instance;
    }

    //WEB-3369 defaultné hodnoty intervalu
    window.airticketActivateFormCustom = {
      oneway () {
        var instance = getIntervalSelect();
        if(instance)
          instance.change(String($('#oneway').data('search_interval')));
      },
      round_trip () {
        var instance = getIntervalSelect();
        if(instance)
          instance.change(String($('#round_trip').data('search_interval')));
      },
      open_jaw () {
        var instance = getIntervalSelect();
        if(instance)
          instance.change(String($('#open_jaw').data('search_interval')));
      }
    };
  }


  // sestaveni objektu s postInitFunkci
  var postInit = {
    letenky: {
      postInitHook: letenky
    },
    jizdenky: {
      postInitHook: sharedFunction
    },
    ubytovani: {
      postInitHook: sharedFunction
    },
    pojisteni: {
      postInitHook: sharedFunction
    },
    auta: {
      postInitHook: sharedFunction
    },
    jazykovePobyty: {
      postInitHook: sharedFunction
    },
    pracovniPobyty: {
      postInitHook: sharedFunction
    },
    dovolena: {
      postInitHook: sharedFunction
    }
  };

  Object.keys(options).forEach((key) => {
    if (instead.length !== 0) {
      if (jQuery.inArray(key, instead) !== 0)
        options[key] = $.extend({}, options[key], postInit[key]);
    } else {
      options[key] = $.extend({}, options[key], postInit[key]);
    }
  });

  return options;

};


// WEBPACK FOOTER //
// ./src/js/global/preparePostInitHookFunction.js